module.exports = __webpack_public_path__ + "img/fill_main3.d0cecedd.png";